import { render, staticRenderFns } from "./WeeksRankingS1Live.vue?vue&type=template&id=10f5f312&"
import script from "./WeeksRankingS1Live.vue?vue&type=script&lang=js&"
export * from "./WeeksRankingS1Live.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports